import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <ArticlePreviewSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}